import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { MprcNumberField } from "components/MprcNumberField";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { ButtonCancel, ButtonConfirm } from "./buttons";
import { MprcContainer } from "./MprcContainer";
import { MprcDialogTitleClose } from "./MprcDialogTitleClose";
import { ExtractErrorInformation, MprcRequestError } from "./MprcRequestErrorReport";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    title: string;
    label?: string;
    placeholder?: string;
    value?: number;
    acceptEmptyValue?: boolean;
    readOnly?: boolean;
    onClose: () => void;
    onConfirm: (value?: number | null) => Promise<void>;
}

////////////////////////////////////////////////////////////////////////////

export const MprcSimpleEditNumberDialog: React.FC<IProps> = (props) => {

    const { title, label, placeholder, acceptEmptyValue = false, readOnly = false, onClose, onConfirm } = props;

    const { enqueueSnackbar } = useSnackbar();

    const [value, setValue] = useState<number | null>(props.value ?? 0);
    const [loading, setLoading] = useState<boolean>(false);

    const isRecordChange = props.value != value;
    const inputError = value != undefined && acceptEmptyValue === false && value == 0;

    ////////////////////////////////////////////////////////////////////////////

    ///
    const handleConfirm = async () => {
        setLoading(true);
        try {
            await onConfirm(value);
        }
        catch (e) {
            let error = ExtractErrorInformation(e as MprcRequestError);
            enqueueSnackbar(error.message, { variant: "error" });
        }
        finally {
            setLoading(false);
        }
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return <Dialog
        open
        fullWidth
        maxWidth="sm"
        onClose={() => onClose()}
    >
        <MprcDialogTitleClose
            shrinkPadding
            title={title}
            onClose={() => onClose()}
        />

        <DialogContent>
            <MprcContainer margin="dense">
                <MprcNumberField
                    value={value}
                    placeholder={placeholder}
                    label={label}
                    disabled={readOnly}
                    max={999999}
                    onChange={value => setValue(value)}
                />
            </MprcContainer>
        </DialogContent>
        <DialogActions>
            <ButtonCancel disabled={loading} variant="contained" onClick={onClose} />
            <ButtonConfirm
                disabled={inputError || loading || !isRecordChange}
                variant="contained"
                onClick={() => handleConfirm()}
            />
        </DialogActions>
    </Dialog>;
};
